import styled from '@emotion/styled';
// @ts-expect-error FIXME: TS6133 - strict mode migration
import { Box, Flex, Text } from '@updater/ui-uds';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import { FC, useState } from 'react';
import { ReactNode } from 'react-markdown';

export const ToggleList: FC<{ label: string; contents: ReactNode }> = ({
  label,
  contents,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Box color="textSoft" onClick={() => setOpen(!open)} {...props}>
      <Flex height="1rem" alignItems="center">
        <Label>{label}</Label>
        <Box minWidth=".5rem" maxWidth="1rem" />
        {open ? <CaretUp size={14} /> : <CaretDown size={14} />}
      </Flex>

      {open ? <Contents pt=".5rem">{contents}</Contents> : null}
    </Box>
  );
};

const Label = styled(Box)`
  font-size: 0.875rem;
`;

const Contents = styled(Box)`
  font-size: 0.75rem;
  line-height: 1rem;
`;
